export const defaultStyle = {
  headerContainer: "w-full",
  //headerContent: "min-h-full items-center flex  mr-[-15px] ml-[-15px] box-border bg-[#4f2170] p-[30px] pl-[15px] relative ",
  headerContent: "headerContent main-nav  ",
  headerContentInner:
    "flex items-center formobileheader px-[15px] max-[1199px]:justify-between md:max-w-md lg:max-w-lg xl:max-w-xl  mx-auto relative",
  brandLogo: "w-full mt-30 logoformoile",

  logoWraperLink: "logoWraperLink lg:w-[21%] md:mx-20 lg:mx-0 md:pl-10 lg:pl-0",
  searchboxStyles: {
    formContainer: `flex justify-between content-center z-[9999] overflow-hidden searchInput print-noshow absolute right-0  rounded-20 border-2 px-8 border-borderGrey py-[0.1rem] mr-[30px] cursor-pointer items-center`,
    form: "ml-[7px] w-full",
    image: "z-[9] lg:h-15 mt-[-7px]",
    input:
      "outline-none bg-transparent text-15 placeholder-darkBlue max-w-full z-5 placeholder-opacity-[0.5]",
  },
  searchBarM: "searchBar w-full flex  bg-repeat-x",
  colofSearchM:
    " colofSearch flex items-center flex-wrap m-0  mx-auto justify-between relative  w-full  max-w-lg xl:max-w-xl w-full px-[15px] items-center flex-row-reverse",
  searchBarContainerM: "searchBarContainer w-full",
}
